import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  if (localStorage.getItem("hdh_token")) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", form);
      localStorage.setItem("hdh_token", res.data.token);
      toast.success("Willkommen zurück!");
      nav("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-luxury px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center text-center mb-8">
          <img src="/logo.png" alt="Haus des Handys" className="h-16 w-auto mb-3" />
          <div className="text-xs text-zinc-500 uppercase tracking-[0.22em]">Admin Bereich</div>
        </div>

        <form onSubmit={submit} className="bg-[#141417] p-8 rounded-3xl border border-white/10 shadow-2xl" data-testid="admin-login-form">
          <div className="flex items-center gap-2 mb-2">
            <Shield className="w-4 h-4 text-[#FF2D40]" />
            <span className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 font-semibold">Sicherer Login</span>
          </div>
          <h1 className="font-display text-2xl font-bold text-white">Anmeldung</h1>
          <p className="text-sm text-zinc-500 mt-1">Zugang zum Verwaltungsbereich</p>

          <div className="mt-6 space-y-4">
            <div>
              <Label className="text-zinc-400">E-Mail</Label>
              <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="bg-[#0A0A0B] border-white/10 text-white" data-testid="login-email" />
            </div>
            <div>
              <Label className="text-zinc-400">Passwort</Label>
              <Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="bg-[#0A0A0B] border-white/10 text-white" data-testid="login-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#DC1928] hover:bg-[#B01829] text-white rounded-full h-11" data-testid="login-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Anmelden"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
